import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IConfig, NgxMaskModule } from 'ngx-mask';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { TextMaskModule } from 'angular2-text-mask';
import { NgBrazil } from 'ng-brazil';
import { NgDragDropModule } from 'ng-drag-drop';
import { FileUploadModule } from 'ng2-file-upload';
import { ClipboardModule } from 'ngx-clipboard';
import { ColorPickerModule } from 'ngx-color-picker';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { LightboxModule } from 'ngx-lightbox';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxSummernoteModule } from 'ngx-summernote';
import { DirectivesModule } from '../directives/directives.module';
import { MaterialModule } from '../material.module';
import { MdModule } from '../md/md.module';
import { PipesModule } from '../pipes/pipes.module';
import { FinanciadoraIntegradorComponent } from './financiadora-integrador.component';

export let options: Partial<IConfig> | (() => Partial<IConfig>) = {};

@NgModule({
  declarations: [FinanciadoraIntegradorComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MdModule,
    MaterialModule,
    TextMaskModule,
    NgBrazil,
    NgSelectModule,
    NgxSpinnerModule,
    FileUploadModule,
    PerfectScrollbarModule,
    NgxChartsModule,
    NgDragDropModule.forRoot(),
    PipesModule,
    ClipboardModule,
    DirectivesModule,
    ColorPickerModule,
    LightboxModule,
    NgxSummernoteModule,
    NgxMaskModule.forRoot(options),
    NgxExtendedPdfViewerModule,
  ],
  exports: [FinanciadoraIntegradorComponent],
})
export class FinanciadoraIntegradorModule {}
